"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _StickyHeaderContext = require("b2b-components/context/StickyHeaderContext");
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("./");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ScrollLink = _ref => {
  let {
    href,
    children,
    onClick,
    className
  } = _ref;
  const [targetId] = _.SCROLL_LINK_HREF_REGEX.exec(href) || [];
  const targetElementRef = (0, _react.useRef)();
  const headerContext = (0, _StickyHeaderContext.useStickyHeader)();
  const handleClick = event => {
    const targetElement = targetElementRef.current;
    if (targetElement) {
      event.preventDefault();
      const stickyElementHeight = headerContext?.ref?.current?.offsetHeight || 0;
      const anchorTargetTop = targetElement.offsetTop;
      const top = anchorTargetTop - stickyElementHeight;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
    onClick?.(href);
  };
  (0, _react.useEffect)(() => {
    if (!targetId) {
      return;
    }
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      targetElementRef.current = targetElement;
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    onClick: handleClick,
    className: (0, _classnames.default)('cds-CMS-ScrollLink', className)
  }, children);
};
exports.ScrollLink = ScrollLink;
//# sourceMappingURL=ScrollLink.js.map